module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--08.757cc63e.png";